import React, { useState } from 'react';
import { 
  Accordion, 
  AccordionSummary, 
  AccordionDetails, 
  Typography, 
  Grid,
  withStyles 
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { appStyles } from '../../styles';

const CollapsibleSection = ({ title, summary, children, onToggle, classes }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    const nextState = !expanded;
    setExpanded(nextState);
    if (onToggle) {
      onToggle(nextState);
    }
  };

  return (
    <div className={classes.collapsibleRoot}>
      <Accordion expanded={expanded} onChange={handleToggle}>
        <AccordionSummary
          classes={{
            root: classes.collapsibleSummaryRoot,
            content: classes.collapsibleSummaryContent,
          }}
        >
          <Grid container alignItems="center">
            <Grid item xs={3} sm={2}>
              <Typography className={classes.collapsibleHeading}>{title}</Typography>
            </Grid>
            <Grid item xs={8} sm={9}>
              {summary}
            </Grid>
            <Grid item xs={1} align="right">
              <ExpandMore className={`${classes.collapsibleExpandIcon} ${expanded ? classes.collapsibleExpanded : ''}`} />
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.collapsibleDetails}>
          {children}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default withStyles(appStyles)(CollapsibleSection);
